import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import ClientStatistic from './ClientStatistic';
import OutcomeOfConsultationStatistic from './OutcomeOfConsultationStatistic';
import type { Statistic as StatisticType } from '../../common/types/statistics/dndStatistics';

type Props = {
  statistic: StatisticType | null | undefined;
};

function Statistic({ statistic }: Props) {
  if (statistic == null) return null;

  const { numberOfPhoneConsultation, numberOfMailContacts, statisticUnderEighteen, statisticOverEighteen } = statistic;

  return (
    <Stack spacing={4}>
      <Paper
        variant='outlined'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 24px',
          maxWidth: '650px',
          minWidth: '300px',
          backgroundColor: '#FAFAFA',
        }}
      >
        <Typography fontSize='1.5rem' fontWeight='bold' mb={2}>
          Anzahl der Beratungen
        </Typography>
        <Typography>Zahl der Telefonberatungen: {numberOfPhoneConsultation}</Typography>
        <Typography>Zahl der Kontakte per E-Mail : {numberOfMailContacts}</Typography>
      </Paper>

      <Paper
        variant='outlined'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 24px',
          maxWidth: '650px',
          minWidth: '300px',
          backgroundColor: '#FAFAFA',
        }}
      >
        <Typography fontSize='1.5rem' fontWeight='bold' mb={2}>
          Erwachsenenberatung
        </Typography>
        <ClientStatistic clientStatistics={statisticOverEighteen.clientStatistic} />
        <OutcomeOfConsultationStatistic
          numberOfClients={statisticOverEighteen.numberOfClients}
          clientStatistics={statisticOverEighteen.outcomeOfConsultationStatistic}
        />
      </Paper>

      <Paper
        variant='outlined'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 24px',
          maxWidth: '650px',
          minWidth: '300px',
          backgroundColor: '#FAFAFA',
        }}
      >
        <Typography fontSize='1.5rem' fontWeight='bold' mb={2}>
          Jugendberatung Telefonische Beratung
        </Typography>
        <ClientStatistic clientStatistics={statisticUnderEighteen.clientStatistic} />
        <OutcomeOfConsultationStatistic
          numberOfClients={statisticUnderEighteen.numberOfClients}
          clientStatistics={statisticUnderEighteen.outcomeOfConsultationStatistic}
        />
      </Paper>
    </Stack>
  );
}

export default Statistic;
